import React from 'react';

/**
 * OverallFeedbackTextarea - Generisk textarea för övergripande feedback
 * Återanvändbar för estimat, offert, upphandling etc.
 * 
 * @param {string} value - Värdet i textarean
 * @param {function} onChange - Callback när värdet ändras
 * @param {string} label - Label för textarean (default: "Övergripande feedback")
 * @param {string} placeholder - Placeholder-text
 * @param {string} helpText - Hjälptext under textarean
 * @param {function} onBlur - Callback vid blur (för aktivitetsloggning)
 * @param {number} rows - Antal rader (default: 4)
 * @param {string} id - ID för textarean (för accessibility)
 */
const OverallFeedbackTextarea = ({
  value,
  onChange,
  label = 'Övergripande feedback',
  placeholder = 'Skriv er sammanfattande feedback eller frågor här...',
  helpText = 'Denna text skickas tillsammans med eventuella radkommentarer.',
  onBlur,
  rows = 4,
  id = 'overallFeedback',
}) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <textarea
        id={id}
        aria-label={label}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-leadme-pink focus:border-transparent"
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      {helpText && (
        <p className="text-xs text-gray-500 mt-1">{helpText}</p>
      )}
    </div>
  );
};

export default OverallFeedbackTextarea;

